export default "__VITE_ASSET__B0$N9ilo__"